/**
 * Determines whether a card object (in any of the three data shapes used by
 * payliance / fluidpay / legacy) is past its expiration date.
 *
 * Month math note: card.exp_month is 1-indexed (1 = January).
 * JavaScript's Date constructor uses 0-indexed months, so passing the raw
 * exp_month value directly as the month argument effectively produces the
 * 1st day of the *following* month — which is exactly the moment the card
 * stops being valid (a card expiring "07/25" is valid through 31 July 2025,
 * i.e. until 2025-08-01 00:00:00).
 *
 * @param {Object} card — the card/payment object from the API
 * @returns {boolean}
 */
export function isCardExpired(card) {
    try {
        let month, year;

        if (card?.card?.exp_month && card?.card?.exp_year) {
            // payliance / fluidpay: separate numeric fields
            month = parseInt(card.card.exp_month, 10);
            year  = parseInt(card.card.exp_year,  10);
            if (year < 100) year += 2000;
        } else if (card?.card?.card?.expirationDate) {
            // fluidpay nested shape: "MMYY" or "MMYYYY" string
            const exp = card.card.card.expirationDate.toString();
            month = parseInt(exp.substring(0, 2), 10);
            year  = parseInt(exp.substring(2),    10);
            if (year < 100) year += 2000;
        } else if (card?.card_expiration) {
            // legacy flat shape: "MM/YYYY" or "MM/YY" string
            const parts = card.card_expiration.split('/');
            month = parseInt(parts[0], 10);
            year  = parseInt(parts[1], 10);
            if (year < 100) year += 2000;
        } else {
            return false;
        }

        // new Date(year, month, 1) — month is intentionally NOT decremented;
        // see the note above explaining why this lands on the correct boundary.
        return new Date() >= new Date(year, month, 1);
    } catch {
        return false;
    }
}
